import React__default from 'react';
import classNames from 'classnames';
import styles from './icons.module.esm.js';

var DeleteIcon = function (_a) {
    var _b;
    var isSmall = _a.isSmall;
    return (React__default.createElement("i", { className: classNames(styles.root, 'icon-cross', (_b = {},
            _b[styles.small] = isSmall,
            _b)) }));
};

export { DeleteIcon as default };
//# sourceMappingURL=Delete.esm.js.map
